import moment from 'moment-timezone';

const getTimezoneAbbr = () => moment.tz(moment.tz.guess()).zoneAbbr();

export default getTimezoneAbbr;
